
const newModel = () => {
    return {
        lichNaovetHogaId: null,
        tuyenDuong: null,
        soluongHoga: null,
        thoigianThuchien: null,

        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        lichNaovetHogaId: null,
        tuyenDuong: null,
        soluongHoga: null,
        thoigianThuchien: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        lichNaovetHogaId: item.lichNaovetHogaId,
        tuyenDuong: item.tuyenDuong,
        soluongHoga: item.soluongHoga,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        lichNaovetHogaId: item.lichNaovetHogaId,
        tuyenDuong: item.tuyenDuong,
        soluongHoga: item.soluongHoga,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        lichNaovetHogaId: null,
        tuyenDuong: null,
        soluongHoga: null,
        thoigianThuchien: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        lichNaovetHogaId: item.lichNaovetHogaId,
        tuyenDuong: item.tuyenDuong,
        soluongHoga: item.soluongHoga,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        lichNaovetHogaId: null,
        tuyenDuong: null,
        soluongHoga: null,
        thoigianThuchien: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const lichNaovetHogaModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


